
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "./bannerForFooter";
import seo from '../../../images/footerLinksImages/productImage/seo.jpg';
function SEO() {
    const features = [
        {
          title: "Search Engine Optimization (SEO)",
          description: "Boost your website's visibility on search engines through strategic keyword optimization and quality content.",
        },
        {
          title: "Pay-Per-Click (PPC) Advertising",
          description: "Drive targeted traffic to your website with highly effective and measurable ad campaigns.",
        },
        {
          title: "Social Media Marketing",
          description: "Build brand awareness and engage your audience through dynamic campaigns on social media platforms.",
        },
        {
          title: "Content Marketing",
          description: "Deliver valuable and relevant content to attract and retain a clearly defined audience.",
        },
        {
          title: "Email Marketing",
          description: "Connect with your audience through personalized email campaigns to drive engagement and conversions.",
        },
        {
          title: "Analytics & Reporting",
          description: "Measure the performance of your marketing efforts and refine strategies based on real-time data.",
        },
        {
          title: "Local SEO",
          description: "Enhance your presence in local searches to attract customers in your geographical area.",
        },
        {
          title: "Influencer Marketing",
          description: "Leverage influencers to amplify your brand message and reach a broader audience.",
        },
        {
          title: "Affiliate Marketing",
          description: "Increase sales through partnerships with affiliate marketers who promote your services.",
        },
        {
          title: "Reputation Management",
          description: "Maintain a positive online presence by monitoring and managing reviews and public perception.",
        },
      ];
    
    return (<>
        <Header />

        <BannerFooter
            title="SEO & Digiral Marketing"
            text="SEO and digital marketing services enhance online visibility and audience engagement. Through strategies like keyword optimization, PPC campaigns, and social media outreach, they drive targeted traffic and boost conversions. By analyzing performance metrics and refining approaches, these services ensure sustainable growth. SEO and digital marketing are vital for building brand authority and reaching potential customers in the competitive digital landscape."
            imageone={seo}
            imagetwo={seo}
        />

<div className="container my-4">
      <h2 className="text-center mb-4">SEO & Digital Marketing</h2>
      <div className="accordion" id="accordionExample">
        {features.map((feature, index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header" id={`heading${index}`}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index}`}
                aria-expanded="false"
                aria-controls={`collapse${index}`}
              >
                {feature.title}
              </button>
            </h2>
            <div
              id={`collapse${index}`}
              className="accordion-collapse collapse"
              aria-labelledby={`heading${index}`}
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                {feature.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
        <ContactForm/>


        <Footer />
    </>)
}

export default SEO